import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { Presentation } from '../../presentation/model/presentation';
import { AgentResponseEvent } from '../manager/avatar-manager';
import { Chat } from '../model/chat';

@Injectable({
  providedIn: 'root',
})
export class ChatApiService {
  private apiUrl = environment.apiUrl;

  constructor(private httpClient: HttpClient) {}

  public sendAudio(id: string, audio: Blob) {
    const form = new FormData();
    form.append('audio_file', audio, 'recording.wav');
    return this.httpClient.post(`${this.apiUrl}/session/${id}/audio`, form);
  }

  public sendMessage(id: string, text: string) {
    return this.httpClient.post(`${this.apiUrl}/session/${id}/text`, { text });
  }

  public repeat(id: string) {
    return this.httpClient.post(`${this.apiUrl}/session/${id}/repeat`, undefined);
  }

  public postAvatarEvent(id: string, event: AgentResponseEvent) {
    return this.httpClient.post(`${this.apiUrl}/session/${id}/avatar-event`, event);
  }

  public getSession(id: string): Observable<Chat> {
    return this.httpClient.get<Chat>(`${this.apiUrl}/session/${id}`);
  }

  public skipPresentation(sessionId: string, id: string) {
    return this.httpClient.post(
      `${this.apiUrl}/session/${sessionId}/presentation/${id}/skip`,
      undefined,
    );
  }

  public presentationEnded(sessionId: string, id: string, seconds: number) {
    return this.httpClient.post(`${this.apiUrl}/session/${sessionId}/presentation/${id}/end`, {
      seconds,
    });
  }

  public getPresentation(sessionId: string, id: string): Observable<Presentation> {
    return this.httpClient.get<Presentation>(
      `${this.apiUrl}/session/${sessionId}/presentation/${id}`,
    );
  }

  public createSession(previousSessionId?: string): Observable<Chat> {
    let params = new HttpParams();

    if (previousSessionId) {
      params = params.set('session_id', previousSessionId);
    }

    return this.httpClient.post<Chat>(`${this.apiUrl}/session`, undefined, { params });
  }

  public getSessionEvents(id: string): EventSource {
    return new EventSource(`${this.apiUrl}/session/${id}/events`);
  }

  public keepAlive(id: string) {
    return this.httpClient.post(`${this.apiUrl}/session/${id}/keepalive`, undefined);
  }
}
